import styles from "./HeaderClients.module.scss";
import manoffice from "../../../../src/assets/images/dashboard_icons/man_office.png";
export default function HeaderClients() {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <span>Posiadani klienci:</span>
          <span className={styles.value}>23</span>
        </div>
        <img src={manoffice} alt="manoffice" />
      </div>
    </>
  );
}
